import React, { useEffect, useState } from 'react';
import classes from "./SubscribePage2.module.css";
import { checkSubscriptionApi, getProductListApi, heApi, printLogsApi, sendOTPApi } from '../Http/http';
import Loader from '../Components/Loader';
import { FaCheck, FaGamepad } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";
import { FaHome } from 'react-icons/fa';

const LoginPage2 = () => {

    const [packs, setPacks] = useState([]);
    const [pack, setPack] = useState(null);
    const [loading, setLoading] = useState(false);
    const [msisdn, setMsisdn] = useState("");

    const [loading2, setLoading2] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (Cookies.get("msisdn")) {
            navigate("/home");
        }
        else {
            fetchMsisdn();
        }
    }, []);

    const fetchMsisdn = async () => {
        try {
            const response = await heApi();
            const response2 = await printLogsApi({
                data: response
            })
            console.log(response, 'response===');

            if (/^\d{7,15}$/.test(response.data)) {
                setMsisdn(response.data);
                // await handleSubmit2(response.data);
            } else {
                console.warn("Msisdn Not Found!", response.data);
            }

            // await handleSubmit2(response?.data);
        } catch (error) {
            console.log(error, 'error---');
        }
    }

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            let msisdnWithCountryCode = msisdn;
            if (msisdnWithCountryCode.startsWith('0')) {
                msisdnWithCountryCode = msisdnWithCountryCode.slice(1);
            }
            if (!msisdnWithCountryCode.startsWith('880')) {
                msisdnWithCountryCode = '880' + msisdnWithCountryCode;
            }
            setLoading2(true);

            const responseLogin = await checkSubscriptionApi({ msisdn: msisdnWithCountryCode });

            if (responseLogin?.data?.result?.statusCode == 200) {
                Cookies.set("msisdn", msisdnWithCountryCode, {
                    expires: 30,
                });
                toast.success("Login Successfully!");
                navigate("/home");
            }

            if (responseLogin?.data?.result?.statusCode == 401) {
                toast.error("Low Balance!");
            }

            if (responseLogin?.data?.result?.statusCode == 403) {
                toast.error("You are not subscribed! Please Subscribe First!");
            }


            setLoading2(false);

        } catch (error) {
            toast.error("Something Went Wrong. Please Try Again!");
        }
    }
    return (
        <div className={classes.container}>
            <div className={classes.section_hero}>

                <div className={classes.header}>
                    <div className={classes.slider_content} style={{ justifyContent: "flex-start", alignItems: "flex-start" }}>
                        <h2 className="tlt fix" style={{ textAlign: "left" }} data-in-effect="fadeInLeft">Door<span> 2 </span>Games</h2>
                    </div>

                    <div className={classes.header_menu}>
                        <div className={classes.menu_icon_container}
                            onClick={() => navigate("/")}
                        >
                            <FaHome className={classes.menu_icon} />
                            <p className={classes.menu_text}>Home</p>
                        </div>
                        <div className={classes.menu_icon_container} onClick={() => navigate("/")}>
                            <FaGamepad className={classes.menu_icon} />
                            <p className={classes.menu_text}>Games</p>
                        </div>

                        <button type="button" className={classes.login_button}
                            onClick={() => navigate("/payment")}
                        >
                            Subscribe
                        </button>
                    </div>
                </div>

                <div className={classes.subscription_form}>

                    {
                        loading ? <Loader /> : (
                            <>
                                <h3 className={classes.title}>Please enter your login number here</h3>

                                <div className={classes.input_container}>
                                    <span className={classes.icon}>📱</span>
                                    <span className={classes.prefix}>+880</span>
                                    <input type='number' placeholder='Enter your Number'
                                        className={classes.input}
                                        value={msisdn}
                                        onChange={(e) => setMsisdn(e.target.value)}
                                    />
                                </div>

                                <button className={classes.next_button} type="button" disabled={loading2}
                                    onClick={handleSubmit}
                                >
                                    {loading2 ? "Loading..." : "Continue"}
                                </button>
                            </>
                        )
                    }


                </div>

                <div className={classes.slider_content}>
                    {/* <h2 className="tlt fix" data-in-effect="fadeInLeft">Door<span> 2 </span>Games</h2> */}
                    <p>© {new Date().getFullYear()} Door2Games. All Rights Reserved</p>
                    <p><strong>Email:</strong> <a href="mailto:support@cloud7bd.com" className={classes.link}>support@cloud7bd.com</a></p>
                    <p><strong>Helpline:</strong> <a href="tel:8801957931782" className={classes.link}>01957931782</a></p>
                </div>

            </div>
        </div>


    )
}

export default LoginPage2;


const profileImages = [
    "/assets/game-images/crazy_match3_512x512.png",
    "/assets/game-images/danger%20runing.png",
    "/assets/game-images/delta_512x512.png",
    "/assets/game-images/double_stickman_512x512.png",
    "/assets/game-images/dragonjump_512x512.png",
    "/assets/game-images/duckshooter_512x512.png",
    "/assets/game-images/emoji%20squeeze.png",
    "/assets/game-images/faces_match_512x512.png",
    "/assets/game-images/feed.png",
    "/assets/game-images/fishnjump_512x512.png",
    "/assets/game-images/flying%20boy.png",
    "/assets/game-images/follow_line_512x512.png",
    "/assets/game-images/Aliens_Memory_512x512.png",
    "/assets/game-images/AngryCatShot_512x512.png",
    "/assets/game-images/AnimalFun_512x512.png",
    "/assets/game-images/BrickDodge_512x512.png",
    "/assets/game-images/CholiJet_512x512.png",
    "/assets/game-images/DangerousCircle_512x512.png",
    "/assets/game-images/Dark_Ninja_512x512.png",
    "/assets/game-images/Emoji_Pong_512x512.png"
];
